/**
 * Le module servi par l'adresse courante, ou `undefined`.
 *
 * Un crochet plutôt qu'une lecture directe : la barre supérieure, l'écran
 * provisoire et les tests posent tous la même question, et une seule réponse
 * évite trois lectures d'URL qui se désaccorderaient.
 */

import { useLocation } from 'react-router-dom';

import type { BackOfficeModule } from './routes.js';
import { moduleOfPath } from './routes.js';

/** Le module correspondant à l'adresse courante. */
export function useCurrentModule(): BackOfficeModule | undefined {
  return moduleOfPath(useLocation().pathname);
}
